import React from 'react';
import PropTypes from 'prop-types';
import colors from 'themeColors';
import { pluralize } from 'utils';
import { useUserContext } from 'context';

const QuotaIndicator = ({ currentOnly = false }) => {
  let { producerQuotas } = useUserContext();
  if (!producerQuotas) return null;

  const multiVenue = producerQuotas.length > 1;
  if (currentOnly) {
    producerQuotas = producerQuotas.filter(pq => pq.isCurrentActive);
  }

  const rows = producerQuotas.map(({ poi, quota, isBillingContact, portalLink }) => {
    let graph;
    let message;

    if (quota.hasOwnProperty('allowed')) {
      let barWidthPercent = quota.used / quota.allowed * 100;
      let barColor = colors.green400;
      if (barWidthPercent >= 50) barColor = colors.yellow400;
      if (barWidthPercent >= 100) {
        barWidthPercent = 100;
        barColor = colors.red400;
      }

      graph = (
        <div className="quota-indicator-graph">
          <div
            className="quota-indicator-graph-bar"
            style={{
              width: barWidthPercent + '%',
              backgroundColor: barColor,
            }}
          />
        </div>
      );

      message = `${quota.used} of ${pluralize(quota.allowed, 'active event')}`;
    } else {
      message = 'No event limit';
    }

    return (
      <div key={poi.id} className="quota-indicator-row">
        {multiVenue && <div className="fw-bold">{poi.name}</div>}

        <div className="d-flex align-items-center">
          {graph}

          <div className="text-sm text-secondary">
            {message}
          </div>

          <div className="flex-spacer" />

          {isBillingContact && (
            <a href={portalLink} target="_blank" rel="noopener noreferrer" className="text-sm fw-bold text-decoration-none">Manage subscription &raquo;</a>
          )}
        </div>
      </div>
    );
  });

  return producerQuotas.length > 0 && (
    <div className="quota-indicator mb-5">
      {rows}
    </div>
  );
};

QuotaIndicator.propTypes = {
  currentOnly: PropTypes.bool,
};

export default QuotaIndicator;
